import { useNavigate } from 'react-router';

import { Button, Dialog, useDialogContext } from '@components/primitives';
import { DialogHeader } from '@components/primitives/Dialog/DialogHeader';

import { Restricted } from '@components/features/Restricted';
import {
  CreateAppForm,
  type CreateAppFormProps,
} from '@components/features/TeamApp/CreateAppForm';

import css from './styles.module.css';

export interface CreateAppDialogContentProps {
  teamUuid: string;
  defaultEnvironment?: CreateAppFormProps['defaultEnvironment'];
}

export function CreateAppDialogContent({
  teamUuid,
  defaultEnvironment,
}: CreateAppDialogContentProps) {
  const dialog = useDialogContext();
  const navigate = useNavigate();
  return (
    <>
      <DialogHeader title="Create new app" />

      <CreateAppForm
        teamUuid={teamUuid}
        defaultEnvironment={defaultEnvironment}
        onCreate={(app) => {
          dialog.close();
          void navigate(`/${teamUuid}/${app.uuid}`);
        }}
      >
        <Dialog.Body>
          <Dialog.Description className={css.createAppDescription}>
            Apps separate your environments and keys for your secure data
            workflows
          </Dialog.Description>

          <CreateAppForm.Fields />
        </Dialog.Body>

        <Dialog.Footer>
          <Button type="button" ghost onClick={dialog.close}>
            Cancel
          </Button>

          <Restricted
            allow="devOrAdmin"
            teamUuid={teamUuid}
            side="top"
            render={
              <CreateAppForm.Submit render={<Button variant="primary" />} />
            }
          >
            Create app
          </Restricted>
        </Dialog.Footer>
      </CreateAppForm>
    </>
  );
}
